import { defineMessages } from 'react-intl';

export default defineMessages({
    interestOnLoan: {
        id: '_.draw_down.choose_amount.interest_on_loan',
        defaultMessage: 'Interest on your loan'
    },
    totalInterest: {
        id: '_.draw_down.choose_amount.total_interest',
        defaultMessage: 'Total interest'
    }
});
